import { render, staticRenderFns } from "./ShipmentsComparison.vue?vue&type=template&id=549070d0&scoped=true"
import script from "./ShipmentsComparison.vue?vue&type=script&lang=js"
export * from "./ShipmentsComparison.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsComparison.vue?vue&type=style&index=0&id=549070d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549070d0",
  null
  
)

export default component.exports